<template>
  <div class="drawer-layout__left-scroll">
    <div class="drawer-layout__left-content">
      <CustomerInfo :info="memberInfo" :currentStep="0" style="margin-bottom: 18px;" @update="$emit('update-member')" @merge-info="$emit('merge-member-info', $event)" />
      <AccommodationListPartial :info="accommodationInfo" :currentStep="0" class="section-gap" @tab-change="$emit('accommodation-tab-change', $event)" />
      <CheckInPetListPartial :info="petsInfo" mode="view" class="section-gap" @pet-tab-click="$emit('pet-tab-click', $event)" />
      <OrderNotrePartial :mode="'view'" :value="orderNote" class="section-gap" />

      <el-button v-if="orderStatus === 'PENDING'" type="primary" round style="width:100%" class="section-gap" @click="$emit('assessed-order', 'confirm')">接受訂單</el-button>
      <el-button
        v-if="orderStatus === 'PENDING' && paymentStatus === 'UNPAID'"
        round
        style="width:100%"
        class="section-gap"
        @click="$emit('assessed-order', 'reject')"
        >拒絕訂單</el-button
      >
      <el-button
        v-if="orderStatus !== 'PENDING' && orderStatus !== 'CHECK_IN' && orderStatus !== 'NO_SHOW' && orderStatus !== 'CANCEL' && orderStatus !== 'CHECK_OUT'"
        type="primary"
        round
        style="width:100%;"
        class="section-gap"
        @click="$emit('check-in')"
      >
        待報到
      </el-button>
      <el-button v-if="orderStatus === 'CHECK_IN'" type="primary" round style="margin-left:0px;width:100%;" class="section-gap" @click="$emit('open-checkout-sign')">
        退房 (簽名確認)
      </el-button>

      <SignatureViewPartial
        v-if="orderStatus === 'CHECK_OUT'"
        title="退房簽名"
        :signature-path="checkoutSignaturePath"
        class="section-gap"
      />
      <SignatureDialog :visible.sync="checkoutSignVisibleProxy" title="退房確認簽名" @save-signature="$emit('save-checkout-signature', $event)" />

      <el-button
        v-if="orderStatus === 'CHECK_IN' || orderStatus === 'CHECK_OUT'"
        round
        icon="el-icon-document-copy"
        style="margin-left:0px;width:100%;"
        class="section-gap"
        @click="$emit('view-check-in-form')"
      >
        住宿單資訊
      </el-button>
    </div>
  </div>
</template>

<script>
import CustomerInfo from './CustomerInfoPartial.vue'
import AccommodationListPartial from './AccommodationListPartial.vue'
import CheckInPetListPartial from './CheckInPetListPartial.vue'
import OrderNotrePartial from './OrderNotrePartial.vue'
import SignatureDialog from './SignatureDialog'
import SignatureViewPartial from './SignatureViewPartial'

export default {
  name: 'ViewOrderLeftContentPartial',
  components: {
    CustomerInfo,
    AccommodationListPartial,
    CheckInPetListPartial,
    OrderNotrePartial,
    SignatureDialog,
    SignatureViewPartial,
  },
  props: {
    memberInfo: { type: Object, default: () => ({}) },
    accommodationInfo: { type: Array, default: () => [] },
    petsInfo: { type: Array, default: () => [] },
    orderNote: { type: String, default: '' },
    orderStatus: { type: String, default: '' },
    paymentStatus: { type: String, default: '' },
    checkoutSignaturePath: { type: String, default: '' },
    isOpenCheckOutSign: { type: Boolean, default: false },
  },
  computed: {
    checkoutSignVisibleProxy: {
      get() {
        return this.isOpenCheckOutSign
      },
      set(val) {
        this.$emit('update:isOpenCheckOutSign', val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/hotel-view-order.scss';
</style>
